'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _linksoftAlbatros = require('linksoft-albatros');

var _pickBy2 = require('lodash/pickBy');

var _pickBy3 = _interopRequireDefault(_pickBy2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var autoTabIndex = 2000; // start index for automatic indexing

var AddToCartAmount = function (_React$Component) {
    (0, _inherits3.default)(AddToCartAmount, _React$Component);

    function AddToCartAmount(props) {
        (0, _classCallCheck3.default)(this, AddToCartAmount);

        var _this = (0, _possibleConstructorReturn3.default)(this, (AddToCartAmount.__proto__ || (0, _getPrototypeOf2.default)(AddToCartAmount)).call(this, props));

        _this.wasSubmitted = false;

        _this.getFormClass = function () {
            var formClass = _this.props.formClass || '';
            if (_this.props.hasChanged) {
                formClass += ' pending-change';
            }
            return formClass;
        };

        _this.handleBlur = function (e) {
            _this.props.submitChanges();
        };

        _this.handleChange = function (e) {
            (0, _linksoftAlbatros.numbersOnly)(e);
            if (e.target.value !== _this.props.displayAmount) {
                _this.onChange(e);
            }
        };

        _this.handleKeyPress = function (e) {
            if (e.key === 'Enter') {
                _this.props.submitChanges();

                e.preventDefault(); // preventDefault so that the form is not submitted

                // the next input in sequence does not need to be directly after the current element (some inputs may be disabled), so we need to try multiple times
                var nextTabIndex = _this.tabIndex + 1;

                while (true) {
                    var nextTab = $('[tabindex=' + nextTabIndex + ']');
                    if (nextTab.length > 0) {
                        $(nextTab).focus();

                        break;
                    }
                    nextTabIndex++;
                    if (nextTabIndex > _this.tabIndex + 30) {
                        // limit the number of tries
                        break;
                    }
                }
            }
        };

        _this.tabIndex = props.tabIndex || autoTabIndex++;
        _this.inputId = 'addToCartAmount_' + _this.tabIndex;
        _this.onChange = props.onChange || function () {};
        _this.onBlur = props.onBlur || function () {};
        _this.canChangeCart = props.canChangeCart;
        _this.processing = props.processing;
        return _this;
    }

    (0, _createClass3.default)(AddToCartAmount, [{
        key: 'render',
        value: function render() {
            var _pickBy = (0, _pickBy3.default)(this.props),
                _pickBy$displayAmount = _pickBy.displayAmount,
                displayAmount = _pickBy$displayAmount === undefined ? '' : _pickBy$displayAmount,
                _pickBy$hasChanged = _pickBy.hasChanged,
                hasChanged = _pickBy$hasChanged === undefined ? false : _pickBy$hasChanged,
                _pickBy$canChangeCart = _pickBy.canChangeCart,
                canChangeCart = _pickBy$canChangeCart === undefined ? false : _pickBy$canChangeCart,
                _pickBy$processing = _pickBy.processing,
                processing = _pickBy$processing === undefined ? false : _pickBy$processing;

            var formClass = this.getFormClass();

            if (hasChanged) {
                this.props.getSummaryForProducts();
            }

            var inputId = this.inputId;

            return _react2.default.createElement(
                'form',
                { className: formClass, autoComplete: 'off' },
                _react2.default.createElement('input', { id: inputId, className: 'input-nubmer-cart', type: 'text',
                    value: displayAmount || '', onChange: this.handleChange, onBlur: this.handleBlur, tabIndex: this.tabIndex, onKeyPress: this.handleKeyPress })
            );
        }
    }]);
    return AddToCartAmount;
}(_react2.default.Component);

AddToCartAmount.propTypes = {
    amount: _react2.default.PropTypes.number,
    displayAmount: _react2.default.PropTypes.string,
    productId: _react2.default.PropTypes.number.isRequired,
    hasChanged: _react2.default.PropTypes.bool.isRequired,
    canChangeCart: _react2.default.PropTypes.bool.isRequired,
    processing: _react2.default.PropTypes.bool.isRequired,
    submitChanges: _react2.default.PropTypes.func.isRequired
};

exports.default = AddToCartAmount;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/cart/components/add-to-cart-amount.js
// module id = 1124
// module chunks = 0